import { render } from "./CancelamentoEstorno.vue?vue&type=template&id=0294ac11"
import script from "./CancelamentoEstorno.vue?vue&type=script&lang=js"
export * from "./CancelamentoEstorno.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__